import { useQuery } from '@tanstack/react-query';
import { getCellTypeOptions } from 'api/taxonomy';
import { CellType } from 'interfaces/cellType';
import { useMemo } from 'react';
import { taxonomyQueryKey } from './taxonomy/useTaxonomy';

export const useCellTypeOptions = () => {
  const query = useQuery({
    queryKey: [...taxonomyQueryKey, 'cell-types'],
    queryFn: ({ signal }) => getCellTypeOptions(signal),
  });

  const mappedCellTypes = useMemo(() => {
    if (!query.data) return [];
    return query.data.map(
      (taxonomy): CellType => ({
        shortId: taxonomy.path.split('.').at(-1),
        id: taxonomy.path,
        displayName: taxonomy.name,
        isAbstract: taxonomy.isAbstract,
        cellTypingSupported: taxonomy.cellTypingSupported,
        cellTypingUnsupportedReason: taxonomy.cellTypingUnsupportedReason,
      })
    );
  }, [query.data]);

  const idToDisplayNameMap = useMemo(
    () =>
      Object.fromEntries(
        mappedCellTypes.flatMap(({ id, shortId, displayName }) => [
          [id, displayName],
          [shortId, displayName],
        ])
      ),
    [mappedCellTypes]
  );

  return { ...query, data: mappedCellTypes, idToDisplayNameMap };
};
